module.exports = __webpack_public_path__ + "static/media/Import_XML_Instructions_FR.44230b42.pdf";